"use client"
import css from "@css/modules/HottestDeals.module.scss"
import React, { Fragment, useCallback, useEffect, useRef } from "react"
import { useDealsContext } from "../context"
import { Spin } from "antd"
import { GridHeader } from "./GridHeader"
import { useUser } from "@lib/api/user"
import NotAuthorizedImg from "../img.png"
import NotAuthorizedImgMobile from "../img-mobile.png"
import Image from "next/image"
import { AuthDialog } from "../AuthDialog"
import { DealRow } from "./DealRow"
import qs from "qs"
import { useViewPortSize } from "@utils/hooks/useViewPortSize"
import { useDeals } from "./useDeals"
import { LoadMoreDeals } from "./LoadMoreDeals"

export function Deals() {
    const { isLoading: isLoadingSession, isAuthenticated } = useUser()
    const { resorts, useMonth, time, sort, withSold, pointsMax, pointsMin } = useDealsContext()
    const getKey = useCallback(
        (page: number) => {
            if (!isAuthenticated) return null // reached the end
            return (
                "/hot-deals?" +
                qs.stringify(
                    {
                        page,
                        resorts,
                        useMonth,
                        time,
                        withSold,
                        sort: sort + ",deal_score:desc,id:desc",
                        pointsMax: pointsMax === 1600 ? undefined : pointsMax,
                        pointsMin: pointsMin === 20 ? undefined : pointsMin
                    },
                    {
                        encodeValuesOnly: true
                    }
                )
            )
        },
        [isAuthenticated, resorts, useMonth, time, withSold, sort, pointsMax, pointsMin]
    )
    const { deals: listings, loadMore, isLoading, hasMore } = useDeals(getKey)

    const ref = useRef<HTMLDivElement>(null)
    const size = useViewPortSize()

    useEffect(() => {
        if (ref.current) {
            ref.current.style.setProperty("--offsetTop", `${ref.current.offsetTop}px`)
        }
    }, [size])

    if (!isAuthenticated && !isLoadingSession) {
        return (
            <div className={css.dealsNotAuthorized}>
                <Image src={NotAuthorizedImg} alt="Not authorized listings" loading="eager" priority={true} />
                <Image className={css.mobileImg} src={NotAuthorizedImgMobile} alt="Not authorized listings" loading="eager" priority={true} />
                <div className={css.shadow}></div>
                <AuthDialog />
            </div>
        )
    }

    const isSpin = isLoading || isLoadingSession
    return (
        <>
            <div className={css.deals} ref={ref}>
                {!!listings?.length && <GridHeader />}
                {listings?.map((i, index) => {
                    const row = <DealRow {...i} key={i.id} index={index} />
                    if (listings.length === index + 1) {
                        return (
                            <Fragment key={i.id}>
                                {row}
                                <LoadMoreDeals onLoadMore={loadMore} hasMore={hasMore} />
                            </Fragment>
                        )
                    }
                    return row
                })}
                {(isLoading || isLoadingSession) && <Spin size="large" className={css.spin} />}
                {!listings?.length && !isSpin && <div className={css.notFound}>There are no listings matching your current filter</div>}
            </div>
        </>
    )
}
